import { useEffect, useRef } from "react";
import { setIsActive } from "./redux-utils/actions/userActions";
import { store } from "@store/index";
import { TIMEOUTS } from "@constants/timeoutConstants";

export default function EventTracker() {
  const activityTimeout = useRef(null);
  const timeout = TIMEOUTS.MOUSE_KEYBOARD_IDLE;

  useEffect(() => {
    setupActivityListeners();

    return () => {
      clearTimeout(activityTimeout.current);
      cleanupActivityListeners();
    };
  }, []);

  const resetActivityTimeout = (_event?) => {
    const currentUserState = store.getState().user;

    if (currentUserState && "isActive" in currentUserState && !currentUserState.isActive) {
      store.dispatch(setIsActive(true));
    }

    clearTimeout(activityTimeout.current);
    activityTimeout.current = setTimeout(() => {
      console.log("User is inactive");
      store.dispatch(setIsActive(false));
    }, timeout); // Stop polling after 2 minutes of inactivity
    return true;
  };

  const setupActivityListeners = () => {
    cleanupActivityListeners();
    document.addEventListener("mousemove", resetActivityTimeout);
    document.addEventListener("keydown", resetActivityTimeout);
    resetActivityTimeout(); // Initialize the inactivity timer on setup
  };

  const cleanupActivityListeners = () => {
    document.removeEventListener("mousemove", resetActivityTimeout);
    document.removeEventListener("keydown", resetActivityTimeout);
  };

  return null;
}
